/**
 * The localStorage key under which we remember the last tenant slug an
 * agent successfully logged into on this device. Used by AgentLogin to
 * prefill, and by AgentEntryRedirect (App.tsx) to fast-path /agent →
 * /t/<slug>/agent. Centralised so a future rename is one edit.
 */
export const LAST_TENANT_SLUG_KEY = 'sb.lastTenantSlug'
